import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterMemoriaCalculoPUMTMTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "CETIP": "N/A",
            "Indexador": "N/A",
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "DataRentabilidadeInicio": dayjs().format(DATE_FORMAT),
            "DataEvento": dayjs().format(DATE_FORMAT),
            "DataLiquidacao": dayjs().format(DATE_FORMAT),
            "VN": 0,
            "VNA": 0,
            "DataIndexador": dayjs().format(DATE_FORMAT),
            "Defasagem": 0,
            "FatorIndexadorAcumulado": 0,
            "TaxaExpectativaIndexador": 0,
            "FatorExpectativaIndexador": 0,
            "FatorForward": 0,
            "TaxaJuros": 0,
            "CalculoDias": "N/A",
            "JurosCapitalizacao": 0,
            "FatorJurosAcumulado": 0,
            "FinanceiroJuros": 0,
            "IncorporacaoJuros": 0,
            "FinanceiroAmortizacao": 0,
            "FinanceiroAmortizacaoExtraordinaria": 0,
            "AtualizacaoMonetaria": 0,
            "Pagamento": 0,
            "Premio": 0,
            "ValorFinal": 0,
            "TaxaRiskFree": 0,
            "TaxaMarcacao": 0,
            "FatorDesconto": 0,
            "ValorMTMFluxo": 0,
            "LOGERRO": ""
        }

        props.loading(true)

        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)

            console.error("Erro ao criar registro:")
            console.error("Mensagem:", err?.message)
            console.error("Response:", err?.response)
            console.error("Response data:", err?.response?.data)
            console.error("Status:", err?.response?.status)

            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            CETIP,
            Indexador,
            DataReferencia,
            DataRentabilidadeInicio,
            DataEvento,
            DataLiquidacao,
            VN,
            VNA,
            DataIndexador,
            Defasagem,
            FatorIndexadorAcumulado,
            TaxaExpectativaIndexador,
            FatorExpectativaIndexador,
            FatorForward,
            TaxaJuros,
            CalculoDias,
            JurosCapitalizacao,
            FatorJurosAcumulado,
            FinanceiroJuros,
            IncorporacaoJuros,
            FinanceiroAmortizacao,
            FinanceiroAmortizacaoExtraordinaria,
            AtualizacaoMonetaria,
            Pagamento,
            Premio,
            ValorFinal,
            TaxaRiskFree,
            TaxaMarcacao,
            FatorDesconto,
            ValorMTMFluxo,
            LOGERRO
        } = newRow

        const body = {
            "CETIP": CETIP,
            "Indexador": Indexador,
            "DataReferencia": DataReferencia,
            "DataRentabilidadeInicio": DataRentabilidadeInicio,
            "DataEvento": DataEvento,
            "DataLiquidacao": DataLiquidacao,
            "VN": VN,
            "VNA": VNA,
            "DataIndexador": DataIndexador,
            "Defasagem": Defasagem,
            "FatorIndexadorAcumulado": FatorIndexadorAcumulado,
            "TaxaExpectativaIndexador": TaxaExpectativaIndexador,
            "FatorExpectativaIndexador": FatorExpectativaIndexador,
            "FatorForward": FatorForward,
            "TaxaJuros": TaxaJuros,
            "CalculoDias": CalculoDias,
            "JurosCapitalizacao": JurosCapitalizacao,
            "FatorJurosAcumulado": FatorJurosAcumulado,
            "FinanceiroJuros": FinanceiroJuros,
            "IncorporacaoJuros": IncorporacaoJuros,
            "FinanceiroAmortizacao": FinanceiroAmortizacao,
            "FinanceiroAmortizacaoExtraordinaria": FinanceiroAmortizacaoExtraordinaria,
            "AtualizacaoMonetaria": AtualizacaoMonetaria,
            "Pagamento": Pagamento,
            "Premio": Premio,
            "ValorFinal": ValorFinal,
            "TaxaRiskFree": TaxaRiskFree,
            "TaxaMarcacao": TaxaMarcacao,
            "FatorDesconto": FatorDesconto,
            "ValorMTMFluxo": ValorMTMFluxo,
            "LOGERRO": LOGERRO
        }

        props.loading(true)

        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const dateColumn = (field, minWidth = 150) => ({
        field,
        headerName: field,
        flex: 1,
        minWidth,
        typeComponent: 'date',
        editable: true,
        renderCell: (params) =>
            params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
    })

    const numberColumn = (field, minWidth = 180) => ({
        field,
        headerName: field,
        flex: 1,
        minWidth,
        typeComponent: 'number',
        type: 'number',
        editable: true
    })

    const columns = [
        { field: 'ID', headerName: '#', disableColumnMenu: true, disableFilter: true, flex: true, minWidth: 80 },

        { field: 'CETIP', headerName: 'CETIP', flex: 1, minWidth: 150, editable: true },
        { field: 'Indexador', headerName: 'Indexador', flex: 1, minWidth: 150, editable: true },

        dateColumn('DataReferencia'),
        dateColumn('DataRentabilidadeInicio', 180),
        dateColumn('DataEvento'),
        dateColumn('DataLiquidacao'),
        dateColumn('DataIndexador'),

        numberColumn('VN'),
        numberColumn('VNA'),
        numberColumn('Defasagem', 150),
        numberColumn('FatorIndexadorAcumulado', 220),
        numberColumn('TaxaExpectativaIndexador', 220),
        numberColumn('FatorExpectativaIndexador', 220),
        numberColumn('FatorForward'),
        numberColumn('TaxaJuros'),
        { field: 'CalculoDias', headerName: 'CalculoDias', flex: 1, minWidth: 150, editable: true },
        { field: 'JurosCapitalizacao', headerName: 'JurosCapitalizacao', flex: 1, minWidth: 180, editable: true },
        numberColumn('FatorJurosAcumulado', 220),
        numberColumn('FinanceiroJuros'),
        numberColumn('IncorporacaoJuros'),
        numberColumn('FinanceiroAmortizacao', 220),
        numberColumn('FinanceiroAmortizacaoExtraordinaria', 260),
        numberColumn('AtualizacaoMonetaria'),
        numberColumn('Pagamento'),
        numberColumn('Premio'),
        numberColumn('ValorFinal'),
        numberColumn('TaxaRiskFree'),
        numberColumn('TaxaMarcacao'),
        numberColumn('FatorDesconto'),
        numberColumn('ValorMTMFluxo'),

        { field: 'LOGERRO', headerName: 'LOGERRO', flex: 1, minWidth: 250, editable: true },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true}
            />
        </div>
    )
}

ParameterMemoriaCalculoPUMTMTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterMemoriaCalculoPUMTMTable